import { useState, useEffect } from 'react';
import styles from './index.module.sass';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../SectionTitle';
import OrderCard from '../../OrderCard';
import getInvoices from '../../Queries/GetInvoices';
import Alert from '../../Alert';

const MyOrders = (props) => {
  const { device, setSessionMessage, history } = props;
  const { screenSize } = device;
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const dataCellWidth = (screenSize === 'phone' && '180px') || `${100 / 1}%`;

  const { t } = useTranslation('myOrders');
  const country = process.env.REACT_APP_COUNTRY;

  let titleItems = '';

  if (country === 'MX') {
    titleItems = t('titleItemsMXN', { returnObjects: true });
  } else {
    titleItems = t('titleItems', { returnObjects: true });
  }

  const months = t('months', { returnObjects: true });

  const [loading, setLoading] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [years, setyears] = useState([]);
  const [invoices, setinvoices] = useState([]);
  const [disabled, setdisabled] = useState(false);
  const [form, setForm] = useState({
    month: currentMonth,
    year: currentYear,
  });
  const [monthLet, setmonthLet] = useState('');

  const changeValue = (e, type) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    function rangeYear() {
      const min = 2009;
      const tmp_years = [];
      for (let i = currentYear; i >= min; i--) {
        tmp_years.push(i);
      }
      setyears(tmp_years);
    }

    async function get_Invoices() {
      const letterMonth = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ];
      setinvoices([]);
      setdisabled(true);
      setLoading(true);

      const response = await getInvoices(form.month, form.year);
      const { typeMessage = 'error', message = '', Invoices = [] } = response;

      setmonthLet(letterMonth[form.month - 1]);
      setSessionMessage(message);

      if (typeMessage === 'error') {
        if (message === '498' || message === '499') return false;
        setAlertText(message);
      } else {
        setinvoices(Invoices);
        setAlertText('');
      }
      setLoading(false);
      setdisabled(false);
    }
    rangeYear();
    get_Invoices();
  }, [currentYear, form.month, form.year, setSessionMessage]);

  return (
    <div id={styles.MyOrders} className={`${styles.container} ${styles[screenSize]}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('title')} subtitle={t('subTitle')} />
      <div className={styles.divSelect}>
        <OrderCard>
          <div>
            <label className={styles.title}>{t('option')}</label>
          </div>
          <div className={styles.selectores}>
            <div>{t('mes')}&nbsp;</div>
            <div>
              <select
                className={styles.inputSelect}
                onChange={(e) => changeValue(e)}
                value={form.month}
                name='month'
                disabled={disabled}>
                {months.map((value, key) => {
                  return (
                    <option value={value.number} key={key}>
                      {value.text}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className={styles.year}>{t('year')}&nbsp;</div>
            <div>
              <select
                className={styles.inputSelect}
                onChange={(e) => changeValue(e)}
                value={form.year}
                name='year'
                disabled={disabled}>
                {years.map((value, key) => {
                  return (
                    <option value={value} key={key}>
                      {value}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className={styles.container}>
            <div className={styles.tabletitle}>
              {t('orders')} {monthLet} {form.year}
            </div>
            {(loading && (
              <div>
                <div className={`${styles.tableContainer}`}>
                  <div className={styles.table}>
                    <div className={`${styles.row} ${styles.tableHeader}`}>
                      {titleItems.map((val, key) => {
                        const { title = '' } = val;
                        return (
                          <div className={styles.cell} style={{ width: dataCellWidth }} key={key}>
                            {title}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <Skeleton variant='rectangular' className={styles.loadingText} />
                <Skeleton variant='rectangular' className={styles.loadingText} />
                <Skeleton variant='rectangular' className={styles.loadingText} />
              </div>
            )) || (
              <div className={`${styles.tableContainer}`}>
                <div className={styles.table}>
                  <div className={`${styles.row} ${styles.tableHeader}`}>
                    {titleItems.map((val, key) => {
                      const { title = '' } = val;
                      return (
                        <div className={styles.cell} style={{ width: dataCellWidth }} key={key}>
                          {title}
                        </div>
                      );
                    })}
                  </div>

                  {invoices.map((val, key) => {
                    const columns = (Array.isArray(titleItems) ? titleItems : []).map(
                      (cellVal, cellKey) => {
                        const {
                          field = '',
                          isLink = false,
                          isImage = false,
                          detail = false,
                          isMoney = false,
                        } = cellVal;
                        let fieldName = '';

                        fieldName = (invoices[key] && invoices[key][field]) || '';
                        if (isMoney) fieldName = `$${fieldName}`;
                        if (field === 'estatus') fieldName = `${t(fieldName)}`;

                        const cell = (
                          <div
                            className={styles.cell}
                            style={{ width: dataCellWidth }}
                            key={cellKey}>
                            {(detail && (
                              <label
                                onClick={() =>
                                  history.push(`DetailMyOrders/${invoices[key]['noPedido']}`)
                                }
                                className={styles.labelDetail}>
                                <i className={`material-icons-outlined ${styles.icon}`}>
                                  visibility
                                </i>
                                <label className={styles.textDecoration}>{t('details')}</label>
                              </label>
                            )) ||
                              (isLink && (
                                <a href={fieldName} target='_blank' rel='noopener noreferrer'>
                                  {fieldName !== '' && (
                                    <label className={styles.link}>
                                      <i className={`material-icons-outlined ${styles.icon}`}>
                                        picture_as_pdf
                                      </i>
                                      <label className={styles.textDecoration}>{t('down')}</label>
                                    </label>
                                  )}
                                </a>
                              )) ||
                              (isImage && <img src={invoices[key][field]} alt='' />) ||
                              fieldName}
                          </div>
                        );
                        return cell;
                      },
                    );
                    return (
                      <div className={`${styles.row}`} key={key}>
                        {columns}
                      </div>
                    );
                  })}
                  <div className={styles.notFound}>{alertText}</div>
                </div>
              </div>
            )}
          </div>
        </OrderCard>
      </div>
    </div>
  );
};

export default MyOrders;
